import React, { useState } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from 'react-toastify';
import { useAllUsersQuery, useChangeStatusMutation, useRidersQuery } from '../../redux/services/usersApi'

const UserStatusModalContent = ({ isRider, isPending, uId, closer }) => {

    const { user } = useAllUsersQuery(undefined, {
        selectFromResult: ({data}) => ({
            user: data?.data?.find((us) => us._id === uId)
        })
    })

    const { rider } = useRidersQuery(undefined, {
        selectFromResult: ({data}) => ({
            rider: data?.data?.find((us) => us._id === uId)
        })
    })

    const [changeStatus, { isLoading }] = useChangeStatusMutation()
    
    const selectedUser = isRider ? rider : user
    const status = isRider ? ['active', 'pending', 'suspended'] : ['active', 'suspended']
    const [selectedStatus, setSelStatus] = useState(isPending ? 'pending' : selectedUser?.userStatus)

    const opts = status.map((val, index) => {
        return (
            <option value={val} key={index}>{val}</option>
        )
    })

    const updateStatus = async() => {
        await changeStatus({ userId: uId, userStatus: selectedStatus })
            .unwrap()
            .then((response) => {
                console.log(response)
                toast.success(response?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                closer()
            })
            .catch((error) => {
                console.log(error)
                toast.error(error?.error, {
                    position: toast.POSITION.TOP_RIGHT
                })
            })
    }

    return (
        
        <>
            <div className="modal d-block" id="modal">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-3 px-4 pull-up">

                        <div className="text-end">
                            <button type="button" className="btn pt-0 pe-0" onClick={closer}><i className="ri-close-line ri-xl"></i></button>
                        </div>
                        <h4 className="modal-title pb-4 px-4">Users status</h4>
                        <div className="pb-4 px-4">
                            <p className='mb-1'>Users Status </p>
                            <select 
                                className='form-control grey-bg'
                                onChange={(e) => setSelStatus(e.target.value)}
                                value={selectedStatus}
                            >
                                {opts}
                            </select>
                        </div>
                        <div className="pb-5 px-4">
                            <button type="button" className="btn custom-modal-btn fw-bold flash-bg" onClick={updateStatus}>
                                { isLoading ? <ClipLoader size={20} /> : 'SAVE' }
                            </button>
                            <button type="button" className="btn fw-bold border-light ms-3" onClick={closer}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserStatusModalContent
